import React from "react";
import { Row, Col, Divider, Button } from "antd";
import styles from "./BookingSummary.module.scss";
import tripCardStyles from "../../Shared/Cards/TripCards/TripCards.module.scss";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import { CreditCardDetails } from "../../../types/PaymentTypes";
import TripLegCard from "../../Shared/Cards/TripCards/TripLegCard";
import calendarIcon from "../../../assets/icons/calendarIcon.svg";
import moment from "moment";
import TripPaymentCard from "../../Shared/Cards/TripCards/TripPaymentCard";
import TripLegCostCard from "../../Shared/Cards/TripCards/TripLegCostCard";
import { leftOutlinedIcon } from "../../../assets/images";
import { useHistory } from "react-router-dom";
import { Tabs } from "../../../types/TripPaginationFilterTypes";
import GrandTotal from "./GrandTotal";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useDashboardCtx } from "../../../context/DashboardContext";

type Props = {
  trip: ITripDetails[];
  ccInfo: CreditCardDetails;
  selectedLeg: ITripDetails;
};

function BookingSummary({ trip, ccInfo }: Props) {
  const history = useHistory();
  const { activeTabCtx } = useDashboardCtx();
  const [, setActiveTab] = activeTabCtx;

  const { width } = useWindowSize();

  function handleBack() {
    const isFromPastServicesTab = trip.every((trip: ITripDetails) =>
      ["Cancelled", "Completed"].includes(trip.statusDetail)
    );
    setActiveTab(isFromPastServicesTab ? Tabs.PAST : Tabs.UPCOMING);
    history.goBack();
  }

  return (
    <Row>
      <Col span={1} />
      <Col xs={22} lg={16}>
        <Row className={styles.marginVertical24}>
          <Button className={styles.backBtn} onClick={handleBack}>
            <img src={leftOutlinedIcon} alt="back_button" />
            Service Summary
          </Button>
        </Row>
        <Row
          gutter={[24, 0]}
          className={`${styles.normalText20} ${styles.marginDown16}`}
        >
          <Col>Planned trips</Col>
          <Col className={styles.tripDate}>
            <img src={calendarIcon} />
            {moment(trip[0]?.tripDate).format("MM/DD/YYYY")}
          </Col>
        </Row>
        {trip.map((leg: ITripDetails, index: number) => (
          <>
            <TripLegCard
              key={leg.bookingId}
              leg={leg}
              legNumber={index + 1}
              isMobileView={width < 992}
            />
            {trip.length > index + 1 && (
              <Divider className={tripCardStyles.dashedDivider} dashed />
            )}
          </>
        ))}
      </Col>
      <Col xs={22} lg={6} className={styles.orderSummaryContainer}>
        <Row className={`${styles.normalText20} ${styles.marginDown16}`}>
          Order summary
        </Row>
        <TripPaymentCard trip={trip} ccInfo={ccInfo} />

        <Divider className={tripCardStyles.dashedDivider} dashed />

        {trip.map((leg: ITripDetails, index: number) => (
          <TripLegCostCard
            key={leg.bookingId}
            leg={leg}
            legNumber={index + 1}
            isWandaPlusTrip={trip[0]?.wandaSubscriptionPlan === "Plus"}
            hasPromoCode={!!trip[0]?.promoCodeDetail?.promoCode}
          />
        ))}

        <GrandTotal trip={trip} />
      </Col>
      <Col span={1} />
    </Row>
  );
}

export default BookingSummary;
